// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-09fc5eaa] .v-data-table-header th .v-data-table-header__icon{color:#fff!important}[data-v-09fc5eaa] .v-pagination{justify-content:start!important}.pagination-column ul[data-v-09fc5eaa]{width:auto}.tbl-row--deleted[data-v-09fc5eaa]{opacity:.5}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
